import { BACKGROUND_IMAGE_DESKTOP, BACKGROUND_IMAGE_MOBILE } from '../elements/assets'
import { FORM_SETTINGS } from '../elements/formSettings'
import { LINK_TITLE } from '../elements/link'
import { LOGO_GARDEN_CONTENT } from './logoGarden'

export const HERO_WITH_FORM_DELIGHT = `
...on heroWithFormDelight_Entry {
  id
  typeHandle

  backgroundColor

  ${ BACKGROUND_IMAGE_DESKTOP }
  ${ BACKGROUND_IMAGE_MOBILE }

  headingTable {
    ... on headingTable_TableRow {
      text: col1
      col1
    }
  }
  
  heading {
    html
  }
  description

  headingTextTable {
    heading
    text
  }

  ${ LINK_TITLE }

  bottomText

  tags {
    title
  }

  ${ LOGO_GARDEN_CONTENT }

  ${ FORM_SETTINGS }
}
`